import "../../styles/physio.css";
import CameraImg from "../../images/camera-1.png";
import CostumerFromImg from "../../images/costumer-form.png";
import IncreasingImg from "../../images/increasing-db.png";
import SearchImg from "../../images/search-1.png";
import VerificationImg from "../../images/verification-bubble.png";
import LockNetworkImg from "../../images/Lock-network.png";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import { physiosPageContent } from "../../data/physiosPageContent";
// Exercise Database Starting Module section
export default function ExerciseDatabase() {
  const currentLang = useCurrentLang();
  const t = physiosPageContent[currentLang];
  return (
    <section id="database" className="physio-section physio-db">
      <div className="glass-card">
        <div className="db-header">
          <span className="physio-eyebrow">{t.exerciseDb.s}</span>
          <h2>{t.exerciseDb.header}</h2>
          <div className="physio-divider" />
          <p className="section-lead">
            {t.exerciseDb.desc}
          </p>
        </div>

        <div className="db-grid">
          <div>
            <ul className="db-feature-list">
              {[
                { icon: SearchImg, text: t.exerciseDb.PERKS.t1},
                { icon: VerificationImg, text:  t.exerciseDb.PERKS.t2},
                { icon: CameraImg, text:  t.exerciseDb.PERKS.t3},
                { icon: IncreasingImg, text:  t.exerciseDb.PERKS.t4},
                { icon: CostumerFromImg, text: t.exerciseDb.PERKS.t5},
                { icon: LockNetworkImg, text:  t.exerciseDb.PERKS.t6},
              ].map(({ icon, text }, i) => (
                <li key={i}>
                  <span className="feat-icon" aria-hidden="true"><img src={icon} style={{maxWidth: "18px"}}/> </span> {/*/*TODO change to icons and not emojis*/}
                  <span>{text}</span>
                </li>
              ))}
            </ul>

            <div className="db-stats">
              {[
                { num: "250+", label: t.exerciseDb.important.l1 },
                { num: "10+", label: t.exerciseDb.important.l2 },
                { num: "1", label: t.exerciseDb.important.l3 },
                { num: "∞", label: t.exerciseDb.important.l4 },
              ].map(({ num, label }, i) => (
                <div className="db-stat-card" key={i}>
                  <div className="stat-num">{num}</div>
                  <div className="stat-label">{label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="db-img">
            <img
              src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80&fit=crop"
              alt="Physiotherapist reviewing exercise database on a tablet"
              width="800"
              height="280"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
